export const REQUEST_HELP_URL = 'https://help.gc.com/hc/en-us';
export const APP_STORE_URL = 'https://apps.apple.com/us/app/gamechanger-team-manager/id1308415878';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.gc.teammanager&hl=en_US&gl=US';
export const GC_URL = 'https://gc.com';
export const GC_LIVE_VIDEO_URL = GC_URL + '/home/live-video';
export const GC_CLASSIC_CLAIM_ACCOUNT_URL = GC_URL + `/claim`;
export const GC_RESEARCH_COMMUNITY = 'https://airtable.com/appVnZ6ac4XDMH9dW/pagr2ZeOjcAEII1lo/form';
export const GC_FACEBOOK = 'https://www.facebook.com/@GetGameChanger';
export const GC_FACEBOOK_ADMINS = 'https://www.facebook.com/groups/gamechangeradmins';
export const GC_REDDIT = 'https://www.reddit.com/r/GameChangerApp/';
export const GC_TERMS = 'https://gc.com/terms';
export const CX_URL = 'https://cx.gc.com';
